import { computed, ref } from 'vue'

import type { Ref, ComputedRef } from 'vue'
import type { MultiselectSearchOption } from '@shared/ui/fields'

import { useCustomerStore } from '@entities/customer'

interface FilterDisciplineOptions {
  initial: string[]
}

interface FilterDisciplineReturn {
  options: ComputedRef<MultiselectSearchOption[]>
  query: Ref<string[]>
  initialValue: ComputedRef<string[]>
  handleSelected: (selected: MultiselectSearchOption[]) => void
}

export const useFilterDiscipline = ({ initial }: FilterDisciplineOptions): FilterDisciplineReturn => {
  const customerStore = useCustomerStore()

  const query = ref<string[]>(initial)

  const options = computed<MultiselectSearchOption[]>(() => {
    return customerStore.getCustomerKidDisciplines.map(item => ({
      id: item.id,
      value: item.id,
      text: `${item.kidName} (${item.code})`,
      selected: query.value.includes(String(item.id)),
    }))
  })

  const initialValue = computed<string[]>(() => {
    return options.value
      .filter(option => option.selected)
      .map(option => option.text)
  })

  const handleSelected = (selected: MultiselectSearchOption[]): void => {
    query.value = selected.map(option => String(option.value))
  }

  return {
    options,
    query,
    initialValue,
    handleSelected,
  }
}